import type { CSSProperties } from 'react';
import { WEDGE_SETTINGS_ACTION } from '@territory/tokens';
import { wedgeExactRole } from './wedgeRoles.js';

export type WedgePhoneOverlayLook = 'phone-overlay-tour-close' | 'phone-overlay-tour-step' | 'phone-overlay-tour-play' | 'phone-overlay-tour-next' | 'phone-overlay-impersonation';
export const isWedgePhoneOverlayLook = (look: string | undefined): look is WedgePhoneOverlayLook => !!look && look.startsWith('phone-overlay-');

const center: CSSProperties = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center' };

// Phone guided tour controls and the impersonation strip, with the released geometry. None draws a transparent hit area.
// The caller passes the current step ink in style, because only it knows which step is current.
export function wedgePhoneOverlayStyle(look: WedgePhoneOverlayLook): CSSProperties {
  if (look === 'phone-overlay-tour-close') return {
    width: 40, height: 40, margin: '-8px -8px -8px 0', borderRadius: 999, border: 0,
    background: 'transparent', color: wedgeExactRole('labelTer'), cursor: 'pointer', flex: 'none', ...center,
  };
  if (look === 'phone-overlay-tour-step') return {
    flex: '1 1 0', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 7, padding: '6px 0 0',
    border: 0, background: 'transparent', cursor: 'pointer', textAlign: 'left',
    fontFamily: wedgeExactRole('font'), color: wedgeExactRole('labelTer'),
  };
  if (look === 'phone-overlay-tour-play') return {
    width: 46, height: 46, borderRadius: 999, flex: 'none',
    border: `1px solid ${wedgeExactRole('separatorBold')}`, background: 'transparent',
    color: wedgeExactRole('label'), cursor: 'pointer', ...center,
  };
  if (look === 'phone-overlay-tour-next') return {
    height: 46, padding: '0 28px', borderRadius: 14, border: 0,
    background: wedgeExactRole('label'), color: wedgeExactRole('bg'),
    fontSize: 16, fontWeight: 700, letterSpacing: '0.1px', cursor: 'pointer', fontFamily: wedgeExactRole('font'),
  };
  return {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    padding: 'calc(env(safe-area-inset-top, 44px) + 4px) 12px 6px',
    background: wedgeExactRole('amber'), color: wedgeExactRole('onAccent'),
    fontFamily: wedgeExactRole('font'), fontSize: 11, fontWeight: 600,
    letterSpacing: 0.3, textTransform: 'uppercase',
    border: 0, cursor: 'pointer', boxShadow: WEDGE_SETTINGS_ACTION.promiseShadow,
  };
}
